export default __webpack_public_path__ + "static/a2-95f573835332f8673d05cfb67e14b55f.jpg";